import React, { useEffect, useState } from "react";
import { User, Profile, Championship } from "../types";
import { getPlayerProfile } from "../actions";
import PlayerProfile from "./playerProfile";
import Loader from "./loader";
import withRedux from "../withRedux";

type OnClose = () => void;

const PlayerSidebar = ({
	user,
	profile,
	onClose,
	isMyProfile,
	showChallengeButton = false,
	challengeButtonParams = {},
	contextParams = {},
	className,
	championship,
}: {
	user: User;
	championship?: Championship;
	profile?: Profile;
	onClose: OnClose;
	isMyProfile: boolean;
	showChallengeButton?: boolean;
	challengeButtonParams?: object;
	contextParams?: object;
	className?: string;
}) => {
	const [playerProfile, setProfile] = useState(profile);

	useEffect(() => {
		if (!profile) {
			setProfile(null);
			getPlayerProfile(user.userId).then((newProfile) => {
				setProfile(newProfile);
			});
		}
	}, [user.userId]);

	if (!playerProfile) {
		return <Loader />;
	}

	if (!className) {
		className = "oBlock";
	}

	return (
		// <div className="contentRightWrapper adjustWidthOfChildElement">
		<PlayerProfile
			profile={playerProfile}
			championship={championship}
			onClose={onClose}
			isMyProfile={isMyProfile}
			showChallengeButton={showChallengeButton}
			challengeButtonParams={challengeButtonParams}
			contextParams={contextParams}
			className={className}
		/>
		// </div>
	);
};

function mapStateToProps({ playerModal: { profiles }, profile: { userId } }, { user }) {
	const isMyProfile = userId === user.userId;

	let profile = null;
	if (user.userId) {
		profile = profiles[user.userId];
	}

	return { profile, user, isMyProfile };
}

export default withRedux({}, mapStateToProps)(PlayerSidebar);
